<script setup lang="ts">
import { dismissToast, toasts, type Toast } from './toast';

function colourClass(type: Toast['type']) {
  return {
    success: 'bg-green-600',
    error: 'bg-red-600',
    info: 'bg-primary-600',
  }[type];
}
</script>

<template>
  <div
    aria-live="polite"
    aria-atomic="false"
    class="pointer-events-none flex flex-col items-end gap-2"
  >
    <div
      v-for="toast in toasts"
      :key="toast.id"
      role="alert"
      :class="['pointer-events-auto flex items-center gap-3 rounded-lg px-4 py-3 text-white shadow-lg text-sm', colourClass(toast.type)]"
    >
      <!-- Success icon -->
      <svg
        v-if="toast.type === 'success'"
        class="h-4 w-4 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2.5"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M4.5 12.75l6 6 9-13.5"
        />
      </svg>
      <!-- Error icon -->
      <svg
        v-else-if="toast.type === 'error'"
        class="h-4 w-4 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2.5"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
      <!-- Info icon -->
      <svg
        v-else
        class="h-4 w-4 shrink-0"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2.5"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
        />
      </svg>
      <span>{{ toast.message }}</span>
      <button
        class="ml-auto text-white/80 hover:text-white transition-colors"
        aria-label="Dismiss notification"
        @click="dismissToast(toast.id)"
      >
        ✕
      </button>
    </div>
  </div>
</template>
